import React, { FC } from "react";
import { BsInfoCircle } from "react-icons/bs";

import Panel from "./Panel";

const DescriptionPanel: FC = () => {
  return (
    <Panel
      initiallyDeployed={false}
      title={
        <>
          <BsInfoCircle className="text-muted" /> Description
        </>
      }

    >
      <p>
        Retrouvez ici tous les professionnels de l'immobilier français sur Internet.
      </p>
      <p>
        Vous pouvez nous sousmettre des ajouts ou des modifications en écrivant à <a href="mailto:directory@wymmo.com">directory@wymmo.com</a>.
      </p>
      <p>
        Les données originales de ce panorama sont aussi disponibles en open source
        {" "}<a target="_blank" rel="noreferrer" href="https://github.com/wymmo/directory">ici</a>{" "}
        et vous pouvez y contribuer.
      </p>
    </Panel>
  );
};

export default DescriptionPanel;
